import React from 'react';

import Field from 'src/views/components/Form/Field';
import { PdUsersSelect } from 'src/views/components/select';

export const name = 'pd_add_responders';
export const label = 'Add responders';
export const type = 'incident_create,incident_update';

export const AdditionalParams = ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => {
  return (
    <Field label="Select Responders to add">
      <PdUsersSelect
        name={`${name}.pd_add_responders`}
        value={values.pd_add_responders}
        onChange={onChange}
        onBlur={onBlur}
        isMulti
      />
    </Field>
  );
};
